/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContainerGraphNodeDto } from './ContainerGraphNodeDto';
import {
    ContainerGraphNodeDtoFromJSON,
    ContainerGraphNodeDtoFromJSONTyped,
    ContainerGraphNodeDtoToJSON,
    ContainerGraphNodeDtoToJSONTyped,
} from './ContainerGraphNodeDto';
import type { ContainerGraphEdgeDto } from './ContainerGraphEdgeDto';
import {
    ContainerGraphEdgeDtoFromJSON,
    ContainerGraphEdgeDtoFromJSONTyped,
    ContainerGraphEdgeDtoToJSON,
    ContainerGraphEdgeDtoToJSONTyped,
} from './ContainerGraphEdgeDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface UserHostGraphTraversalResponse
 */
export interface UserHostGraphTraversalResponse {
    /**
     * 
     * @type {string}
     * @memberof UserHostGraphTraversalResponse
     */
    seedType?: string;
    /**
     * 
     * @type {string}
     * @memberof UserHostGraphTraversalResponse
     */
    seedEntityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserHostGraphTraversalResponse
     */
    seedResolved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserHostGraphTraversalResponse
     */
    windowDays?: number;
    /**
     * 
     * @type {number}
     * @memberof UserHostGraphTraversalResponse
     */
    maxNodes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserHostGraphTraversalResponse
     */
    truncated?: boolean;
    /**
     * 
     * @type {Array<ContainerGraphNodeDto>}
     * @memberof UserHostGraphTraversalResponse
     */
    nodes?: Array<ContainerGraphNodeDto>;
    /**
     * 
     * @type {Array<ContainerGraphEdgeDto>}
     * @memberof UserHostGraphTraversalResponse
     */
    edges?: Array<ContainerGraphEdgeDto>;
    /**
     * 
     * @type {string}
     * @memberof UserHostGraphTraversalResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof UserHostGraphTraversalResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof UserHostGraphTraversalResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof UserHostGraphTraversalResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the UserHostGraphTraversalResponse interface.
 */
export function instanceOfUserHostGraphTraversalResponse(value: object): value is UserHostGraphTraversalResponse {
    return true;
}

export function UserHostGraphTraversalResponseFromJSON(json: any): UserHostGraphTraversalResponse {
    return UserHostGraphTraversalResponseFromJSONTyped(json, false);
}

export function UserHostGraphTraversalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHostGraphTraversalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seedType': json['seedType'] == null ? undefined : json['seedType'],
        'seedEntityId': json['seedEntityId'] == null ? undefined : json['seedEntityId'],
        'seedResolved': json['seedResolved'] == null ? undefined : json['seedResolved'],
        'windowDays': json['windowDays'] == null ? undefined : json['windowDays'],
        'maxNodes': json['maxNodes'] == null ? undefined : json['maxNodes'],
        'truncated': json['truncated'] == null ? undefined : json['truncated'],
        'nodes': json['nodes'] == null ? undefined : ((json['nodes'] as Array<any>).map(ContainerGraphNodeDtoFromJSON)),
        'edges': json['edges'] == null ? undefined : ((json['edges'] as Array<any>).map(ContainerGraphEdgeDtoFromJSON)),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function UserHostGraphTraversalResponseToJSON(json: any): UserHostGraphTraversalResponse {
    return UserHostGraphTraversalResponseToJSONTyped(json, false);
}

export function UserHostGraphTraversalResponseToJSONTyped(value?: UserHostGraphTraversalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seedType': value['seedType'],
        'seedEntityId': value['seedEntityId'],
        'seedResolved': value['seedResolved'],
        'windowDays': value['windowDays'],
        'maxNodes': value['maxNodes'],
        'truncated': value['truncated'],
        'nodes': value['nodes'] == null ? undefined : ((value['nodes'] as Array<any>).map(ContainerGraphNodeDtoToJSON)),
        'edges': value['edges'] == null ? undefined : ((value['edges'] as Array<any>).map(ContainerGraphEdgeDtoToJSON)),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

